import axios from "axios";

export default function acknowledgeTicket({ id, priority, assigneeId, assigneeName }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/tickets/${id}/acknowledge`, {
        priority,
        assignee_id: assigneeId,
        assignee_name: assigneeName,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
